import { createStore } from "vuex";
import argonConfig from './argonConfig';
import auth from './auth';
import cataloguerForm from './cataloguerForm';
import importExcel from './importExcel';
import mcr from './mcr';
import userForn from './userForn';

export default createStore({
  modules: {
    argonConfig,
    auth,
    cataloguerForm,
    importExcel,
    mcr,
    userForn
  }
});
